<template>
    <div class="right_box_main">
        <!-- 面包屑导航 -->
        <div class="mianbao">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/griddingindex' }"
                    >网格工作</el-breadcrumb-item
                >
                <el-breadcrumb-item>社区议事协商</el-breadcrumb-item>
                <el-breadcrumb-item>上报协商</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="card-box">
            <div class="card-4">
                <el-card>
                    <el-form
                        :inline="true"
                        :model="searchlist"
                        class="demo-form-inline"
                        size="mini"
                    >
                        <el-form-item
                            label="议题名称:"
                            style="margin: 0 30 0 0"
                        >
                            <el-input
                                v-model="searchlist.consultName"
                                placeholder="请输入议题名称"
                                style="width: 200px"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="上报人:" style="margin: 0 30 0 0">
                            <el-input
                                v-model="searchlist.reporterName"
                                placeholder="请输入上报人"
                                style="width: 200px"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="议题大类:"
                            style="margin: 0 30 0 0"
                        >
                            <el-select
                                v-model="searchlist.consultType"
                                placeholder="--请选择--"
                                @change="dlChange"
                            >
                                <el-option
                                    v-for="item in dlList"
                                    :key="item.id"
                                    :label="item.consultName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="议题小类:"
                            style="margin: 0 30 0 0"
                        >
                            <el-select
                                v-model="searchlist.consultCut"
                                placeholder="--请选择--"
                            >
                                <el-option
                                    v-for="item in xlList"
                                    :key="item.id"
                                    :label="item.consultName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="searchlistdata"
                                >查询</el-button
                            >
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" @click="searchlistReset"
                                >重置</el-button
                            >
                        </el-form-item>
                    </el-form>
                    <!-- 表格盒子 -->

                    <el-table
                        :data="tableData"
                        :header-cell-style="{ background: '#f8fafa' }"
                        border
                        align="center"
                        current-row-key
                        highlight-current-row
                    >
                        <el-table-column
                            align="center"
                            prop="index"
                            label="序号"
                            width="70"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="consultName"
                            label="议题名称"
                            width="300px"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="consultType"
                            label="议题大类"
                            width="240px"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="consultCut"
                            label="议题小类"
                            width="160px"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="reportSource"
                            label="上报时间"
                            width="220px"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="reporterName"
                            label="上报人"
                            width="120px"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="reporterPhone"
                            label="手机号"
                            width="160px"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="reportSource"
                            label="来源"
                            width="130px"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            label="操作"
                            width="200"
                            fixed="right"
                        >
                            <template slot-scope="scope">
                                <el-tooltip
                                    class="item"
                                    effect="light"
                                    content="查看"
                                    placement="top-start"
                                >
                                    <button
                                        class="iconfont icon-chakan tabBtn"
                                        @click="
                                            showDialog(scope.row.id, 'detail')
                                        "
                                        style="color: #9da09c"
                                    ></button>
                                </el-tooltip>
                                <el-tooltip
                                    class="item"
                                    effect="light"
                                    content="采纳"
                                    placement="top-start"
                                    style="fontweight: bold"
                                >
                                    <button
                                        class="iconfont icon-shenhe tabBtn"
                                        @click="
                                            showDialog(scope.row.id, 'caina')
                                        "
                                        style="color: #ff04ed"
                                    ></button>
                                </el-tooltip>
                                <el-tooltip
                                    class="item"
                                    effect="light"
                                    content="删除"
                                    placement="top-start"
                                >
                                    <button
                                        class="iconfont icon-icon7 tabBtn"
                                        @click="showdeletepanduan(scope.row.id)"
                                        style="color: #dd3020"
                                    ></button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageConfig.pageNo"
                        :page-sizes="[10, 20, 30, 50]"
                        :page-size="pageConfig.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pageConfig.total"
                    ></el-pagination>
                </el-card>
            </div>
        </div>

        <!-- 弹出框查看 -->
        <el-dialog title="查看" :visible.sync="showadd" width="500px">
            <el-form :model="addform" label-width="110px" size="mini">
                <el-form-item label="议题名称：" prop="consultName">
                    <el-input
                        v-model="addform.consultName"
                        style="width: 300px"
                        disabled
                    ></el-input>
                </el-form-item>
                <el-form-item label="议题大类：" prop="consultName">
                    <el-input
                        v-model="addform.consultName"
                        style="width: 300px"
                        disabled
                    ></el-input>
                </el-form-item>
                <el-form-item label="议题小类：" prop="consultName">
                    <el-input
                        v-model="addform.consultName"
                        style="width: 300px"
                        disabled
                    ></el-input>
                </el-form-item>
                <el-form-item label="上报时间：" prop="status">
                    <el-date-picker
                        v-model="addform.date"
                        type="datetime"
                        placeholder="选择日期时间"
                        disabled
                        style="width: 300px"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="上报人：" prop="consultName">
                    <el-input
                        v-model="addform.consultName"
                        style="width: 300px"
                        disabled
                    ></el-input>
                </el-form-item>
                <el-form-item label="手机号：" prop="consultName">
                    <el-input
                        v-model="addform.consultName"
                        style="width: 300px"
                        disabled
                    ></el-input>
                </el-form-item>
                <el-form-item label="来源：" prop="consultName">
                    <el-input
                        v-model="addform.consultName"
                        style="width: 300px"
                        disabled
                    ></el-input>
                </el-form-item>
                <el-form-item label="附件：" prop="consultName">
                    <a href="#">下载</a>
                </el-form-item>
            </el-form>
            <!-- <div class="boontbtn" v-if="is">
        <el-button type="primary" size="small" style="margin: 0 30px" @click="saveadddata">保存</el-button>
        <el-button type="info" size="small" @click="showadd == false">取消</el-button>
      </div>-->
        </el-dialog>
    </div>
</template>

<script>
import { tabdata } from "@/mixins/tabledataMix.js"
// import { getdlListInform, getxlListInform, lookSbxsInform } from "@/api/api"
let token = JSON.parse(window.localStorage.getItem("user"))
import request from "@/utils/request.js"
export default {
    mixins: [tabdata],
    components: {},
    data() {
        return {
            tableDataUrl: "",
            rowid: "",
            addform: {},
            showadd: false,
            dlList: [],
            xlList: [],
            rules: [],
        }
    },
    created() {
        this.initTableDataUrl("admin/consul/info/findConsultList")
        getdlListInform().then((res) => {
            this.dlList = res.content
        })
    },

    methods: {
        //选择大类
        dlChange(id) {
            //   getxlListInform({consultCut:id}).then(res => {
            //     this.xlList = res.content;
            //   });
            let fd = new FormData()
            fd.append("pageNo", 1)
            fd.append("pageSize", 20)
            let params = JSON.stringify({ parentId: id })
            fd.append("findConsultType", params)
            let res = request({
                url: "admin/consulType/info/findConsultTypeList",
                method: "POST",
                data: fd,
            }).then((res) => {
                this.xlList = res.content.list
            })
        },
        //查询
        searchlistdata() {
            this.getPageDatas()
        },
        //重置
        searchlistReset() {
            this.searchlist = {}
        },
        //分页
        handleCurrentChange(val) {
            this.pageConfig.pageNo = val
            this.getPageDatas()
        },
        handleSizeChange(val) {
            this.pageConfig.pageSize = val
            this.pageConfig.pageNo = 1
            this.getPageDatas()
        },

        //弹框控制
        showDialog(id, flag) {
            this.rowid = id
            if (flag == "detail") {
                this.showadd = true
                let fd = new FormData()
                fd.append("id", id)
                let res = request({
                    url: "admin/consul/info/findConsultById",
                    method: "POST",
                    data: fd,
                }).then((res) => {
                    this.addform = res.content
                })
            } else {
                this.$confirm("是否已经跟上报人电话沟通过？", "提示", {
                    confirmButtonText: "是",
                    cancelButtonText: "否",
                    type: "warning",
                })
                    .then(() => {})
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "取消采纳！",
                        })
                    })
            }
        },
        //删除
        showdeletepanduan(id) {
            this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let fd = new FormData()
                    fd.append("id", id)
                    var res = request({
                        url: "admin/consul/info/deleteConsult",
                        method: "POST",
                        data: fd,
                    })
                        .then((res) => {
                            this.$message({
                                message: "删除成功",
                                type: "success",
                            })
                            this.getPageDatas()
                        })
                        .catch((res) => {
                            this.$message({
                                message: "删除失败：" + res.message,
                                type: "error",
                            })
                        })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    })
                })
        },
    },
}
</script>

<style lang="less" scoped>
//  包裹两个卡片的盒子
.card-box {
    width: 100%;
    display: flex;
    // 左边树状列表卡片
    .card-l {
        width: 270px;
    }
    .card-r {
        flex: 1;
        height: 320px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .card-0 {
            width: 32.5%;
            height: 320px;
            .onebuttom {
                height: 258px;
                div {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .card-3 {
            width: 32.5%;
            height: 320px;
            .onebuttom {
                height: 258px;
                div {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .topbarnav {
            display: flex;
            align-items: center;
            div {
                box-sizing: border-box;
                padding: 0 10px;
                font-size: 14px;
            }
        }
    }
}
.card-4 {
    margin-top: 12px;
    padding: 0;
    width: 100%;
}
// 表格的盒子
.table_card {
    // overflow: hidden;
    // 解决表格无法自适应宽度
    // width: calc(100vw - 500px);
    margin: 16px 0 0 0;
    .el-table {
        width: 100%;
        // 表格里的按钮
        .tabBtn {
            margin: 0 6px;
        }
    }
}
.threestyleimg {
    display: flex;
    // align-items: center;
    // justify-content: center;
    flex-wrap: wrap;
    .threestyleimgtu {
        width: 80%;
        height: 70%;
        // background-color: red;
        display: flex;
        // justify-content: center;
        // align-items: center;
    }
    .threestyleimgbtn {
        width: 80%;
        height: 30%;
        margin-top: 20px;

        // background-color: green;
        display: flex;
        // justify-content: center;
        // align-items: center;

        position: relative;
        div {
            width: 170px;
            height: 30%;
            background: #ffffff;
            border: 1px solid #cad4dc;
            text-align: center;
            line-height: 30px;
        }
        input {
            position: absolute;
            width: 172px;
            height: 32px;
            opacity: 0;
            cursor: pointer;
        }
    }
}
</style>